import React, { useEffect, useState } from "react";
import { Form, Input, Row, Col, Radio, Checkbox, Divider, Modal,Typography } from "antd";
import {
  UserOutlined,
  CalculatorOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useTranslation } from 'react-i18next'; // <-- Add this


// Import the image for the worksheet modal
import worksheetImg from './worksheet-table.png.png'; // Place your image in the same folder or update the path
  const { Title } = Typography;


const W4Form = ({ value = {}, onChange }) => {
  const [form] = Form.useForm();
    const [worksheetModalOpen, setWorksheetModalOpen] = useState(false);
          const { t } = useTranslation();
    

  useEffect(() => {
    if (value) form.setFieldsValue(value);
  }, [value, form]);

  const handleValuesChange = (_, allValues) => {
    if (onChange) onChange(allValues);
  };

  return (
    <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
      {/* Filing Status Section */}
      <Row align="middle" gutter={8} style={{ marginBottom: 8 }}>
        <Col>
          <UserOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col>
                  {/* <h3 style={{ margin: 0 }}>Filing Status</h3> */}
                  <Title
            style={{
              margin: 0,
              // color: '#0E4A9F',
              fontWeight: 600,
              fontSize: 'calc(16px + 0.2vh)',
            }}
            level={5}
          >
            {t('onboarding.filingStatus')}
          </Title>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <p style={{ marginBottom: 4 }}>{t('onboarding.filingStatusQuestion')}</p>
          <Form.Item
            name="filingStatus"
            rules={[{ required: true, message: t('onboarding.filingStatusRequired') }]}
            style={{ marginBottom: 0 }}
          >
            <Radio.Group style={{ display: "flex", gap: 20 }}>
              <Radio value="single">
                {t('onboarding.filingSingle')} <span style={{ color: "#888" }}>{t('onboarding.filingSingleDesc')}</span>
              </Radio>
              <Radio value="marriedJoint">
                {t('onboarding.filingMarriedJoint')} <span style={{ color: "#888" }}>{t('onboarding.filingMarriedJointDesc')}</span>
              </Radio>
              <Radio value="headOfHousehold">
                {t('onboarding.filingHead')} <span style={{ color: "#888" }}>{t('onboarding.filingHeadDesc')}</span>
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      <Divider />

      {/* Tax Calculator Section */}
      <Row align="middle" gutter={8} style={{ marginBottom: 8 }}>
        <Col>
          <CalculatorOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col>
          <h3 style={{ margin: 0 }}>Tax Calculators</h3>
        </Col>
      </Row>

      {/* Vertical options */}
      <Row>
        <Col span={24}>
          <span style={{ fontWeight: 500 }}>Use any one of the options:</span>
          <div style={{ marginLeft: 20, marginBottom: 8 }}>
            <p>
              a) Use IRS Calculator{" "}
              <a
                href="https://www.irs.gov/W4App"
                target="_blank"
                rel="noreferrer"
                  style={{ color: "#0E4A9F", padding: "2px 6px", borderRadius: "4px" }}
              >
                (www.irs.gov/W4App)
              </a>
            </p>
            <p>
              b) Use the Worksheet{" "}
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  setWorksheetModalOpen(true);
                }}
                rel="noreferrer"
                                  style={{ color: "#0E4A9F", padding: "2px 6px", borderRadius: "4px" }}

              >
                (Click here to view)
              </a>
            </p>
            <Form.Item name="taxOptionC" valuePropName="checked" style={{ marginBottom: 0 }}>
              <Checkbox>
                c) If there are only two jobs total, you may check the box. This
                option is generally more accurate than (b) if pay at the lower
                paying job is more than half of the pay at the higher paying
                job. Otherwise, (b) is more accurate.
              </Checkbox>
            </Form.Item>
          </div>
        </Col>
      </Row>

      <Modal
        open={worksheetModalOpen}
        onCancel={() => setWorksheetModalOpen(false)}
        footer={null}
        width={900}
        bodyStyle={{ padding: 0, textAlign: "center" }}
        centered
      >
        <img
          src={worksheetImg}
          alt="Worksheet Table"
          style={{ maxWidth: "100%", borderRadius: 8, margin: 0 }}
        />
      </Modal>

      <Divider />

      {/* Claim Dependent and Other Credits */}
      <Row align="middle" gutter={8} style={{ marginBottom: 8 }}>
        <Col>
          <TeamOutlined style={{ fontSize: 18, color: "#1677ff" }} />
        </Col>
        <Col>
          <Title
            style={{
              margin: 0,
              // color: '#0E4A9F',
              fontWeight: 600,
              fontSize: 'calc(16px + 0.2vh)',
            }}
            level={5}
          >
            {t('onboarding.dependentsAndOtherCredits')}
          </Title>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="step3"
            label={t('onboarding.taxCreditLabel')}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="step4a"
            label={t('onboarding.otherIncomeLabel')}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="step4b"
            label={t('onboarding.totalDeductionsLabel')}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="step4c" label={t('onboarding.extraWithholdingLabel')}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default W4Form;


